import InteractiveAnnotation from "./interactiveAnnotation";
import { setFontStyle } from "../canvasUtils";

export default class DeepDeeAnalysisChart extends InteractiveAnnotation {
  constructor(position, options, context) {
    super(position, options);
    
    this.x= (context.transform.canvasSize.w / 2) - 340;
    this.y = 0;
    this.context = context;
    this.isActive = false;

    this.chartImg = document.getElementById("bar-chart").toDataURL();
    this.img = new Image();
    this.img.src = this.chartImg;

    this.font = "30px Calibri";
    this.fontColor = "white";
    this.backgroundColor = "#707070";

    this.diagnosisColor = context.diagnosisColor;
    this.diagnosisText = context.diagnosisText;
    this.disclaimerText = "Note: This data and analysis is provided for REFERENCE \nONLY and is not intended to replace a consultation \nwith a qualified ophthalmic professional.";
    this.disclaimerLines = this.disclaimerText.split("\n");
    this.titleText = "DIABETIC RETINOPATHY AI ANALYSIS";
  }


  draw(ctx) {
    this.drawChart(ctx);
    this.drawText(ctx);
    this.drawTopText(ctx);
    if (this.isActive){
      if(this.activeCorner) this.drawInteractionBoxes(ctx)
      else if(this.isTextActive) this.drawTextInteractionBoxes(ctx)    
    }       
  }

  drawChart(ctx) {
    ctx.drawImage(this.img, this.x + 675, this.y + 100, 525, 525);
  }

  drawText(ctx){
    setFontStyle(ctx, this);
    for (var i = 0; i < this.disclaimerLines.length; i++)    
      ctx.fillText(this.disclaimerLines[i], this.x, this.y + 400 + (50 * i));

    ctx.font = "bold 100px Calibri";
    ctx.fillStyle = this.diagnosisColor;
    ctx.fillText(this.diagnosisText, this.x, this.y + 100);
  }

  drawTopText(ctx){
    ctx.fillStyle = this.backgroundColor;
    ctx.fillRect(this.x, this.y, 1200, 65);

    setFontStyle(ctx, this);
    ctx.font = "45px Calibri";
    ctx.textAlign = "center";
    ctx.fillText(this.titleText, this.x + 600, this.y + 12);
  }

  isInBounds(x, y) {
    return this.isBetween(x, this.x, this.x + 1300)   
    && this.isBetween(y, this.y, this.y + 550);;
  }

  isBetween(value, bound1, bound2) {
    const min = Math.min(bound1, bound2);
    const max = Math.max(bound1, bound2);
    return value >= min && value <= max;
  }

  mousedown(x, y) {
    super.mousedown(x, y);
    this.signalReady();
  }

  mousemove(x, y) {
    this.updateLocation(x, y);
    this.signalReady();
  }

  updateLocation(x, y) {
    this.x = x;
    this.y = y;
  }
  
  deactivate() {
    this.isActive = false;
    this.signalReady();
  }
}